/**
 * @module AddressCheckHero
 * @description
 */
import { useContext } from "react";
import dynamic from "next/dynamic";
import { FuelContext } from "@/providers/fuel-provider";
import ServiceCheckSingleLine from "@/components/blocks/ServiceCheckForm";
import styles from "./HeroAddressCheck.module.css";

const PhoneButton = dynamic(() => import("@/blocks/Buttons/PhoneButton"));
const position = "HERO ADDRESS CHECK";

/**
 * @function Component
 * @description Hero that displays headline and predictive service check
 */
const Component = (props) => {
  const {
    headline,
    horizonHeadline,
    subHeadline,
    background = "lady-tablet-night-cityscape",
    form,
    showFormLead = false,
    customStyles,
    useSelectAreasLegal = true,
  } = props;
  const { phoneHeavy } = useContext(FuelContext);
  const backgroundPath = `${process.env.imagePath}/sections/hero/${background}`;

  return (
    <section
      className={`component u-theme-dark ${styles.component} ${customStyles && customStyles.component}`}
      style={{ backgroundImage: `url(${backgroundPath}--large.jpg )` }}
    >
      <div
        className={`l-container ${styles.component__wrapper} ${customStyles && customStyles.component__wrapper}`}
      >
        <div className="g-row">
          <div
            className={`g-col g-col--two-thirds ${customStyles && customStyles.component__layout}`}
          >
            <div className={`${styles.component__contentWrapper}`}>
              {horizonHeadline ? (
                <h2 className={styles.component__headlineWrapper}>
                  <span
                    className={`h1 component__horizonHeadline ${styles.component__horizonHeadline}`}
                  >
                    {horizonHeadline[0]}
                  </span>
                  <span
                    className={`h1 component__horizonHeadline ${styles.component__horizonHeadline}`}
                  >
                    {horizonHeadline[1]}
                  </span>
                  <span
                    className={`h1 component__horizonHeadline ${styles.component__horizonHeadline}`}
                  >
                    {horizonHeadline[2]}
                  </span>
                </h2>
              ) : (
                <h2 className={`${styles.component__headline} h1`}>
                  {headline}
                </h2>
              )}

              {phoneHeavy ? (
                <>
                  <div
                    className={
                      customStyles && customStyles.component__ctaContainer
                    }
                  >
                    <h3 className="h4">
                      Call now to speak with an expert about the plans available
                      in your area.
                    </h3>
                    <PhoneButton position={position} />
                  </div>

                  {useSelectAreasLegal && (
                    <p className={styles.component__selectAreasLegal}>
                      Frontier<sup>&reg;</sup> Fiber Internet available in
                      select&nbsp;areas.
                    </p>
                  )}
                </>
              ) : (
                <div
                  className={
                    customStyles && customStyles.component__ctaContainer
                  }
                >
                  {subHeadline && <h3 className="h4">{subHeadline}</h3>}

                  {showFormLead && (
                    <p className={`h6 ${styles.component__formLead}`}>
                      <span
                        className={`icon icon-location-marker ${styles.component__icon}`}
                      />
                      <span>
                        Enter your address to view plans in your area.
                      </span>
                    </p>
                  )}

                  {form || <ServiceCheckSingleLine />}

                  {useSelectAreasLegal && (
                    <p className={styles.component__selectAreasLegal}>
                      Frontier<sup>&reg;</sup> Fiber Internet available in
                      select&nbsp;areas.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={`${styles.component__mobileBackground} ${customStyles && customStyles.component__mobileBackground}`}
          style={{ backgroundImage: `url( ${backgroundPath}.jpg )` }}
        />
      </div>
    </section>
  );
};

export default Component;
